$(document).ready(function () {

    //Recent Blog Articles
    $('.carousel--blog-articles').each(function() {
        $(this).slick({
            arrows: true,
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            appendArrows: $(this).next('.control-container'),
            appendDots: $(this).next('.control-container').find('.dots-container'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: false,
                        // dots: true
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 580,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });

    // Advice Articles
    $('.carousel--articles').each(function() {
        $(this).slick({
            arrows: true,
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            appendArrows: $(this).next('.control-container'),
            appendDots: $(this).next('.control-container').find('.dots-container'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: false,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 580,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });



// Product Comparison Table
    $('.js-carousel--ppc').each(function() {
        $(this).slick({
            arrows: true,
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            appendArrows: $(this).next('.control-container'),
            appendDots: $(this).next('.control-container').find('.dots-container')
        });
    });

});